import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Alunos = ({
  API,
  getAuthHeaders,
  setCurrentView,
  students,
  turmas,
  loadStudents,
  currentUser,
  getFilteredTurmas,
  gerarLinkWhatsApp,
  planoInfo,
  onShowPlanos
}) => {
  const [showForm, setShowForm] = useState(false);
  const [editingStudent, setEditingStudent] = useState(null);
  const [showTransferForm, setShowTransferForm] = useState(false);
  const [transferringStudent, setTransferringStudent] = useState(null);
  const [searchStudent, setSearchStudent] = useState('');
  const [selectedTurmaFilter, setSelectedTurmaFilter] = useState('todas'); // NOVO: filtro por turma
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [formData, setFormData] = useState({
    nome_completo: '',
    data_nascimento: '',
    contato: '',
    turma_id: ''
  });
  const [transferData, setTransferData] = useState({
    nova_turma_id: ''
  });

  // Função para normalizar texto (remover acentos e converter para minúsculas)
  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  // useEffect para filtrar alunos (busca + turma)
  useEffect(() => {
    let filtered = students;

    // Filtro por turma
    if (selectedTurmaFilter !== 'todas') {
      filtered = filtered.filter(student => student.turma_id === selectedTurmaFilter);
    }

    // Filtro por busca de nome
    if (searchStudent.trim()) {
      filtered = filtered.filter(student =>
        normalizeText(student.nome_completo).includes(normalizeText(searchStudent))
      );
    }

    setFilteredStudents(filtered);
  }, [students, searchStudent, selectedTurmaFilter]);

  // Inicializar filteredStudents quando students mudarem
  useEffect(() => {
    setFilteredStudents(students);
  }, [students]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingStudent) {
        await axios.put(`${API}/students/${editingStudent.id}`, formData, {
          headers: getAuthHeaders()
        });
      } else {
        await axios.post(`${API}/students`, formData, {
          headers: getAuthHeaders()
        });
      }
      setTimeout(() => loadStudents(true), 300);
      setShowForm(false);
      setEditingStudent(null);
      setFormData({ nome_completo: '', data_nascimento: '', contato: '', turma_id: '' });
      alert('Aluno salvo com sucesso!');
    } catch (error) {
      if (error.response?.status === 403 && error.response?.data?.detail?.includes('Limite')) {
        if (onShowPlanos && window.confirm(`${error.response.data.detail}\n\nDeseja ver os planos disponíveis?`)) {
          onShowPlanos();
        }
      } else if (error.response?.data?.detail) {
        alert(`Erro: ${error.response.data.detail}`);
      } else {
        alert('Erro ao salvar aluno');
      }
    }
  };

  const handleTransferSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/students/${transferringStudent.id}/transfer`, transferData, {
        headers: getAuthHeaders()
      });
      setTimeout(() => loadStudents(true), 300);
      setShowTransferForm(false);
      setTransferringStudent(null);
      setTransferData({ nova_turma_id: '' });
      alert('Aluno transferido com sucesso!');
    } catch (error) {
      if (error.response?.data?.detail) {
        alert(`Erro: ${error.response.data.detail}`);
      } else {
        alert('Erro ao transferir aluno');
      }
    }
  };

  const handleEdit = (student) => {
    setEditingStudent(student);
    setFormData({
      nome_completo: student.nome_completo,
      data_nascimento: student.data_nascimento,
      contato: student.contato,
      turma_id: student.turma_id
    });
    setShowForm(true);
  };

  const handleTransfer = (student) => {
    setTransferringStudent(student);
    setTransferData({ nova_turma_id: '' });
    setShowTransferForm(true);
  };

  const handleDelete = async (studentId) => {
    if (window.confirm('Tem certeza que deseja remover este aluno?')) {
      try {
        await axios.delete(`${API}/students/${studentId}`, {
          headers: getAuthHeaders()
        });
        setTimeout(() => loadStudents(true), 300);
        alert('Aluno removido com sucesso!');
      } catch (error) {
        if (error.response?.data?.detail) {
          alert(`Erro: ${error.response.data.detail}`);
        } else {
          alert('Erro ao remover aluno');
        }
      }
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow mb-6">
          <button
            onClick={() => setCurrentView('dashboard')}
            className="mb-4 px-4 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 touch-manipulation"
          >
            ← Voltar ao Dashboard
          </button>
          {/* Indicador de limite do plano */}
          {planoInfo && planoInfo.alunos && planoInfo.plano !== 'free' && (
            <div className={`mb-3 flex items-center justify-between p-3 rounded-lg text-sm ${
              planoInfo.alunos.atual >= planoInfo.alunos.limite
                ? 'bg-red-50 border border-red-200 text-red-700'
                : planoInfo.alunos.atual >= planoInfo.alunos.limite * 0.8
                ? 'bg-yellow-50 border border-yellow-200 text-yellow-700'
                : 'bg-blue-50 border border-blue-200 text-blue-700'
            }`}>
              <span>
                <strong>{planoInfo.alunos.atual}/{planoInfo.alunos.limite}</strong> alunos ativos
                {' '}(Plano {planoInfo.plano_nome})
              </span>
              {planoInfo.alunos.atual >= planoInfo.alunos.limite && onShowPlanos && (
                <button
                  onClick={onShowPlanos}
                  className="ml-3 px-3 py-1 bg-emerald-600 text-white rounded-lg text-xs font-semibold hover:bg-emerald-700"
                >
                  Fazer Upgrade
                </button>
              )}
            </div>
          )}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
              Gerenciar Alunos
            </h1>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
              {/* Botão Alunos Faltantes */}
              <button
                onClick={() => setCurrentView('faltantes')}
                className="px-4 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 flex items-center justify-center touch-manipulation"
              >
                <span className="text-sm mr-2">📋</span>
                <span className="hidden sm:inline">Alunos Faltantes</span>
                <span className="sm:hidden">Faltantes</span>
              </button>

              {/* Botão Relatório */}
              <button
                onClick={() => setCurrentView('relatorio-turma')}
                className="px-4 py-3 bg-sky-500 text-white rounded-lg hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-500 flex items-center justify-center touch-manipulation"
              >
                <span className="text-sm mr-2">📊</span>
                <span className="hidden sm:inline">Relatório</span>
                <span className="sm:hidden">Relatório</span>
              </button>

              {/* Botão Novo Aluno - Apenas Admin e Moderador */}
              {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') && (
                <button
                  onClick={() => setShowForm(true)}
                  className="px-4 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 touch-manipulation"
                >
                  <span className="sm:hidden">+ Aluno</span>
                  <span className="hidden sm:inline">Novo Aluno</span>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Alerta de Demonstração - Apenas para visitante */}
        {currentUser?.tipo === 'visitante' && (
          <div className="mb-6 p-4 bg-yellow-100 border border-yellow-400 rounded-lg">
            <div className="flex items-center">
              <span className="text-yellow-800 text-lg font-semibold">
                ⚠️ MODO DEMONSTRAÇÃO: Apenas Visualização
              </span>
            </div>
          </div>
        )}

        {showForm && (
          <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 mb-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
                {editingStudent ? '✏️ Editar Aluno' : '➕ Novo Aluno'}
              </h2>
              <button
                onClick={() => {
                  setShowForm(false);
                  setEditingStudent(null);
                  setFormData({ nome_completo: '', data_nascimento: '', contato: '', turma_id: '' });
                }}
                className="p-2 text-gray-400 hover:text-gray-600 transition-colors sm:hidden"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="sm:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome Completo</label>
                  <input
                    type="text"
                    value={formData.nome_completo}
                    onChange={(e) => setFormData({...formData, nome_completo: e.target.value})}
                    className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Digite o nome completo..."
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Data de Nascimento</label>
                  <input
                    type="date"
                    value={formData.data_nascimento}
                    onChange={(e) => setFormData({...formData, data_nascimento: e.target.value})}
                    className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Contato</label>
                  <input
                    type="tel"
                    value={formData.contato}
                    onChange={(e) => setFormData({...formData, contato: e.target.value})}
                    className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="(00) 00000-0000"
                    required
                  />
                </div>

                <div className="sm:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Turma</label>
                  <select
                    value={formData.turma_id}
                    onChange={(e) => setFormData({...formData, turma_id: e.target.value})}
                    className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Selecione uma turma</option>
                    {turmas.map(turma => (
                      <option key={turma.id} value={turma.id}>{turma.nome}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-green-500 text-white text-base font-medium rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors touch-manipulation"
                >
                  {editingStudent ? '✅ Atualizar Aluno' : '➕ Criar Aluno'}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowForm(false);
                    setEditingStudent(null);
                    setFormData({ nome_completo: '', data_nascimento: '', contato: '', turma_id: '' });
                  }}
                  className="flex-1 px-6 py-3 bg-gray-500 text-white text-base font-medium rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors touch-manipulation"
                >
                  ❌ Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        {showTransferForm && (
          <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Transferir Aluno: {transferringStudent?.nome_completo}
            </h2>
            <form onSubmit={handleTransferSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nova Turma</label>
                <select
                  value={transferData.nova_turma_id}
                  onChange={(e) => setTransferData({nova_turma_id: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Selecione a nova turma</option>
                  {turmas.filter(t => t.id !== transferringStudent?.turma_id).map(turma => (
                    <option key={turma.id} value={turma.id}>{turma.nome}</option>
                  ))}
                </select>
              </div>
              <div className="flex space-x-4">
                <button
                  type="submit"
                  className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  Transferir
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowTransferForm(false);
                    setTransferringStudent(null);
                    setTransferData({ nova_turma_id: '' });
                  }}
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Lista de Alunos</h2>

          {/* Campo de busca */}
          {/* Filtros de busca e turma */}
          <div className="mb-6 bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-sm font-medium text-gray-700 mb-3">🔍 Filtros</h3>
            <div className="flex flex-col sm:flex-row gap-4">
              {/* Busca por nome */}
              <div className="flex-1">
                <label className="block text-xs text-gray-600 mb-1 sm:hidden">Buscar aluno</label>
                <input
                  type="text"
                  placeholder="🔍 Buscar aluno por nome..."
                  value={searchStudent}
                  onChange={(e) => setSearchStudent(e.target.value)}
                  className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Filtro por turma */}
              <div className="w-full sm:w-72">
                <label className="block text-xs text-gray-600 mb-1 sm:hidden">Filtrar por turma</label>
                <select
                  value={selectedTurmaFilter}
                  onChange={(e) => setSelectedTurmaFilter(e.target.value)}
                  className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="todas">🏫 Todas as Turmas</option>
                  {getFilteredTurmas().map(turma => {
                    const alunosNaTurma = students.filter(s => s.turma_id === turma.id).length;
                    return (
                      <option key={turma.id} value={turma.id}>
                        {turma.nome} ({alunosNaTurma} alunos)
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          {/* Interface Responsiva: Desktop Tabela + Mobile Cards */}
          <div>
            {/* Contador de resultados */}
            <div className="mb-4 text-sm text-gray-600">
              {filteredStudents.length} aluno{filteredStudents.length !== 1 ? 's' : ''} encontrado{filteredStudents.length !== 1 ? 's' : ''}
              {selectedTurmaFilter !== 'todas' && (
                <span> na turma {turmas.find(t => t.id === selectedTurmaFilter)?.nome}</span>
              )}
            </div>

            {/* Versão Desktop - Tabela */}
            <div className="hidden lg:block overflow-x-auto">
              <table className="w-full border-collapse border border-gray-200 bg-white rounded-lg overflow-hidden shadow-sm">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Nome</th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Data Nascimento</th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Contato</th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Turma</th>
                    <th className="border border-gray-300 px-4 py-3 text-center font-medium text-gray-700">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredStudents.map((student) => (
                    <tr key={student.id} className="hover:bg-gray-50 transition-colors">
                      <td className="border border-gray-300 px-4 py-3 font-medium">{student.nome_completo}</td>
                      <td className="border border-gray-300 px-4 py-3 text-sm text-gray-600">{student.data_nascimento}</td>
                      <td className="border border-gray-300 px-4 py-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm">{student.contato}</span>
                          {student.contato && (
                            <a
                              href={gerarLinkWhatsApp(student.contato, student.nome_completo, 'geral')}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="ml-2 p-1 text-green-600 hover:text-green-800 hover:bg-green-50 rounded transition-colors duration-200"
                              title={`Enviar mensagem para ${student.nome_completo}`}
                            >
                              📱
                            </a>
                          )}
                        </div>
                      </td>
                      <td className="border border-gray-300 px-4 py-3 text-sm">
                        {turmas.find(t => t.id === student.turma_id)?.nome || 'N/A'}
                      </td>
                      <td className="border border-gray-300 px-4 py-3 text-center">
                        {(currentUser?.tipo === 'visitante' || currentUser?.tipo === 'professor') ? (
                          <span className="text-gray-500 italic text-sm">Apenas visualização</span>
                        ) : (
                          <div className="flex justify-center space-x-2">
                            <button
                              onClick={() => handleEdit(student)}
                              className="px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600 transition-colors"
                            >
                              Editar
                            </button>
                            <button
                              onClick={() => handleTransfer(student)}
                              className="px-3 py-1 bg-orange-500 text-white text-sm rounded hover:bg-orange-600 transition-colors"
                            >
                              Transferir
                            </button>
                            <button
                              onClick={() => handleDelete(student.id)}
                              className="px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 transition-colors"
                            >
                              Remover
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Versão Mobile/Tablet - Cards */}
            <div className="lg:hidden space-y-4">
              {filteredStudents.map((student) => (
                <div key={student.id} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900 text-lg leading-tight">{student.nome_completo}</h4>
                      <p className="text-sm text-gray-600 mt-1">{turmas.find(t => t.id === student.turma_id)?.nome || 'N/A'}</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <p className="text-xs text-gray-500 uppercase font-medium">Data de Nascimento</p>
                      <p className="text-sm text-gray-900">{student.data_nascimento}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 uppercase font-medium">Contato</p>
                      <div className="flex items-center space-x-2">
                        <span className="text-sm text-gray-900">{student.contato || 'Não informado'}</span>
                        {student.contato && (
                          <a
                            href={gerarLinkWhatsApp(student.contato, student.nome_completo, 'geral')}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-green-600 hover:text-green-800 transition-colors duration-200"
                            title={`Enviar mensagem para ${student.nome_completo}`}
                          >
                            📱
                          </a>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Ações Mobile */}
                  <div className="pt-3 border-t border-gray-100">
                    {(currentUser?.tipo === 'visitante' || currentUser?.tipo === 'professor') ? (
                      <div className="text-center py-2">
                        <span className="text-gray-500 italic text-sm">Apenas visualização</span>
                      </div>
                    ) : (
                      <div className="flex flex-col sm:flex-row gap-2">
                        <button
                          onClick={() => handleEdit(student)}
                          className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors touch-manipulation"
                        >
                          ✏️ Editar
                        </button>
                        <button
                          onClick={() => handleTransfer(student)}
                          className="flex-1 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors touch-manipulation"
                        >
                          🔄 Transferir
                        </button>
                        <button
                          onClick={() => handleDelete(student.id)}
                          className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors touch-manipulation"
                        >
                          🗑️ Remover
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {filteredStudents.length === 0 && (
                <div className="text-center py-8">
                  <div className="text-4xl mb-4">🔍</div>
                  <p className="text-gray-500 text-lg">Nenhum aluno encontrado</p>
                  <p className="text-gray-400 text-sm mt-2">Tente ajustar os filtros de busca</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alunos;
